import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';
import { useController } from 'react-hook-form';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const CheckboxMultipleSelector = ({
  name,
  reference,
  label,
  preloadedValue = false,
}) => {
  const dataProvider = useDataProvider();
  const [users, setUsers] = useState([]);

  const {
    field,
    fieldState: { isTouched, invalid },
    formState: { isSubmitted },
  } = useController({ name });

  useEffect(() => {
    dataProvider
      .getList(reference, {
        pagination: { page: 1, perPage: 1000 },
        sort: { order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setUsers(data);
      })
      .catch(error => {
        console.error('Error fetching users: ', error);
      });

    // Convert preloaded values to IDs if they are objects
    if (preloadedValue && Array.isArray(field.value)) {
      const preloadedIds = field.value.map(item =>
        typeof item === 'object' ? item.id : item
      );
      field.onChange(preloadedIds);
    }
  }, [reference]); //eslint-disable-line react-hooks/exhaustive-deps

  // Ensure field value contains only IDs
  useEffect(() => {
    if (Array.isArray(field.value)) {
      const onlyIds = field.value.map(item =>
        typeof item === 'object' ? item.id : item
      );
      if (onlyIds.some((id, index) => id !== field.value[index])) {
        field.onChange(onlyIds);
      }
    }
  }, [field.value, field]);

  const selectedUserIds =
    field.value?.map(item => (typeof item === 'object' ? item.id : item)) || [];
  const selectedUsers = users.filter(user => selectedUserIds.includes(user.id));

  const handleChange = (event, value) => {
    field.onChange(value.map(user => user.id));
  };

  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={users}
      disableCloseOnSelect
      getOptionLabel={option => option.username}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={handleChange}
      value={selectedUsers}
      sx={{
        maxWidth: { xs: '100%', sm: '500px' },
        '& .MuiFilledInput-root': { paddingTop: '24px' },
        '& .MuiAutocomplete-tag': { marginBottom: '6px' },
        '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
          minWidth: '0px',
        },
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.username}
        </li>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          error={(isTouched || isSubmitted) && invalid}
        />
      )}
    />
  );
};
